var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "text-center timer-wrapper"
  }, [_c('vue-countdown-timer', {
    attrs: {
      "start-time": _vm.startTime,
      "end-time": _vm.endTime,
      "interval": 1000,
      "label-position": "end",
      "end-text": 'This auction has ended!'
    },
    on: {
      "start_callback": function start_callback($event) {
        return _vm.startCallBack('event started');
      },
      "end_callback": function end_callback($event) {
        return _vm.endCallBack('event ended');
      }
    },
    scopedSlots: _vm._u([{
      key: "countdown",
      fn: function fn(scope) {
        return _c('div', {
          staticClass: "timer"
        }, [_c('a-space', {
          attrs: {
            "size": 8
          }
        }, [_c('span', {
          staticClass: "value"
        }, [_vm._v(_vm._s(scope.props.days) + " d")]), _c('span', {
          staticClass: "divider"
        }, [_vm._v("|")]), _c('span', {
          staticClass: "value"
        }, [_vm._v(_vm._s(scope.props.hours) + " h")]), _c('span', {
          staticClass: "divider"
        }, [_vm._v("|")]), _c('span', {
          staticClass: "value"
        }, [_vm._v(_vm._s(scope.props.minutes) + " m")]), _c('span', {
          staticClass: "divider"
        }, [_vm._v("|")]), _c('span', {
          staticClass: "value"
        }, [_vm._v(_vm._s(scope.props.seconds) + " s")])])], 1);
      }
    }])
  }, [_vm._v(" > ")])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }